import Switch from '@mui/material/Switch'
import styles from './PromptConfiguration.module.css'

interface EnableToggleProps {
  isEnabled: boolean
  isTogglingEnabled: boolean
  existingPrompt: any
  onToggle: (newValue: boolean) => void
}

function EnableToggle({
  isEnabled,
  isTogglingEnabled,
  existingPrompt,
  onToggle,
}: EnableToggleProps) {
  // Determine which state class to use
  const getStateClass = () => {
    if (!existingPrompt) {
      return styles.enableToggleChipNoPrompt
    }
    return isEnabled ? styles.enableToggleChipActive : styles.enableToggleChipInactive
  }

  return (
    <div className={styles.toggleContainer}>
      <div className={`${styles.enableToggleChip} ${getStateClass()}`}>
        <Switch
          checked={isEnabled}
          onChange={(e) => onToggle(e.target.checked)}
          disabled={isTogglingEnabled || !existingPrompt}
          color='success'
          size='small'
        />
        <span className={styles.enableToggleText}>
          {isTogglingEnabled
            ? 'Saving...'
            : isEnabled
            ? 'AI Auditing Enabled'
            : 'AI Auditing Disabled'}
        </span>
        <span className={styles.enableToggleIcon}>{isEnabled ? '✓' : '○'}</span>
      </div>
      {!existingPrompt && (
        <div className={styles.toggleHelperText}>
          Save a prompt to database before enabling AI auditing
        </div>
      )}
    </div>
  )
}

export default EnableToggle
